export enum SignalRChannelEnum {
    Chat = 'Chat',
    Voting = 'Voting'
}
